import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { AssistantPagesContent } from '@/pageContents/kiEinstellungen/AssistantPagesContent';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

const AssistantPages: PageWithLayout = () => (
    <>
        <Helmet>
            <title>Seiteninformationen | Starjack Backoffice</title>
        </Helmet>
        <Box sx={{ p: 3 }}>
            <AssistantPagesContent />
        </Box>
    </>
);

AssistantPages.isProtected = true;
AssistantPages.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
AssistantPages.permissions = [Permission.ADMIN];

export default AssistantPages;
